import React from 'react';
import Tooltip from 'react-bootstrap/Tooltip';
import { OverlayTrigger } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { IAllStates } from '../../../store/rootReducer';
import { setSelectedSupplier } from '../../../store/brand/clientSlice';
import { Company } from '../../../model/user/Company';
import { CustomImageHandler } from '../../../shared/components/CustomImageHandler';

interface ISupplierHeaderListProps {
    suppliers: Company[];
}

export function SupplierHeaderList({ suppliers }: ISupplierHeaderListProps) {
    const { selectedSupplier } = useSelector((state: IAllStates) => state.client);
    const dispatch = useDispatch();

    const selectSupplier = (supplier: Company) => {
        if (selectedSupplier?.id !== supplier.id) {
            dispatch(setSelectedSupplier(supplier));
        }
    };

    const visibleSuppliers = suppliers?.slice(0, 6) ?? [];
    const isSelectedOutOfList =
        !!selectedSupplier?.id && visibleSuppliers.every(supplier => supplier.id !== selectedSupplier?.id);

    return (
        <>
            {visibleSuppliers.map(item => (
                <div onClick={() => selectSupplier(item)} key={item.id} className="mr-2 cursor-pointer">
                    <OverlayTrigger
                        key={`${item.id}${item?.displayName}`}
                        overlay={
                            <Tooltip placement="bottom" id={`tooltip-bottom`}>
                                {item.displayName}
                            </Tooltip>
                        }
                    >
                        <div
                            className={
                                item?.id === selectedSupplier?.id
                                    ? 'position-relative user-border rounded-circle'
                                    : 'position-relative'
                            }
                        >
                            <CustomImageHandler
                                photoPath={item?.profilePhoto?.thumbnail}
                                classes="agency-filter-rounded-img img-cover"
                                altTag="User Profile"
                                placeholder="/icons/UserPlaceholder.png"
                                name={item.displayName}
                            />
                            {item?.id === selectedSupplier?.id && <p className="active-user mb-0">Active</p>}
                        </div>
                    </OverlayTrigger>
                </div>
            ))}
            {isSelectedOutOfList && (
                <div onClick={() => selectSupplier(selectedSupplier)} className="mr-2 cursor-pointer">
                    <OverlayTrigger
                        overlay={
                            <Tooltip placement="bottom" id={`tooltip-bottom`}>
                                {selectedSupplier.displayName}
                            </Tooltip>
                        }
                    >
                        <div className={'position-relative user-border rounded-circle'}>
                            <CustomImageHandler
                                photoPath={selectedSupplier?.profilePhoto?.thumbnail}
                                thumbnailPath={selectedSupplier?.profilePhoto?.thumbnail}
                                classes="agency-filter-rounded-img img-cover"
                                altTag="User Profile"
                                name={selectedSupplier.displayName}
                            />
                            <p className="active-user mb-0">Active</p>
                        </div>
                    </OverlayTrigger>
                </div>
            )}
        </>
    );
}
